import React from 'react';
import PropTypes from 'prop-types'; // Import PropTypes for props validation
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import Modal from 'components/Modal';
import Button from 'components/Button';
import FormSelect from 'components/FormSelect';
import 'components/DeleteFringeGroup/styles.scss';
import { useGroupMutation } from 'utils/api/mutations'; // Add the fetchGroups function
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import { toast } from 'react-toastify'; // <-- import toast here
import { useGroupFringeQuery } from 'utils/api/queries';
import { toastStyle } from 'utils/helper'; // optional: your custom style

const DeleteFringeGroup = props => {
  const { activeBudget } = useHomeScreenContext();

  const removeGroupMutation =
    useGroupMutation.useRemoveFringeFromGroupMutation();

  const { delData } = useHomeScreenContext();
  const { data: groupDetails } = useGroupFringeQuery.useGroupFringeDetailsQuery(
    {}
  );

  const groupArray = groupDetails?.data.data || []; // Adjust based on API response

  const groupOptions = groupArray.map(group => ({
    value: group.id,
    label: group.name,
  }));

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm();

  const onSubmit = data => {
    const payload = {};
    payload.fringe = delData;
    payload.active_id = activeBudget;
    payload.group = data.group.value;

    removeGroupMutation.mutate(payload, {
      onSuccess: () => {
        props?.closeFolder();
        reset();
        props?.refetch();
      },
      onError: error => {
        let message =
          'An error occurred while creating the group. Please try again.';
        console.error('Error deleting fringe group:', error);
        if (error?.response?.data?.length) {
          message = error.response.data[0];
        }
        toast.error(message, toastStyle);
      },
    });
  };

  return (
    <Modal
      onHide={props?.closeFolder}
      show={props?.showDeleteFringeGroup}
      size="lg"
      className="create-budget"
      bodyClass="create-budget__body"
      centered
    >
      <h1 className="create-budget__body__header">Remove Fringe</h1>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '4rem',
          }}
        >
          <FormSelect
            label="Group"
            name="group"
            control={control}
            options={groupOptions}
            placeholder="Select Group"
            rules={{ required: 'Please select a group' }}
            error={errors?.group?.message}
            styles={{
              menuPortal: base => ({
                ...base,
                zIndex: 9999, // Ensure it appears above other modal content
              }),
              menu: base => ({
                ...base,
                maxHeight: '120px',
                overflowY: 'auto',
              }),
              menuList: base => ({
                ...base,
                maxHeight: '120px',
                overflowY: 'auto',
              }),
              control: base => ({
                ...base,
                minHeight: '20px',
              }),
            }}
          />
        </div>
        <div className="create-budget__body__action">
          <Button
            label="Cancel"
            type="reset"
            className="create-budget__action__cancel"
            variant="red-outlined"
            onClick={props?.closeFolder}
          />
          <Button
            label="Remove"
            className="create-budget__action__confirm"
            type="submit"
          />
        </div>
      </Form>
    </Modal>
  );
};

// Define propTypes for props validation
DeleteFringeGroup.propTypes = {
  closeFolder: PropTypes.func.isRequired,
  showDeleteFringeGroup: PropTypes.bool.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default DeleteFringeGroup;
